var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-jumbotron',{attrs:{"header":"404","lead":"Denne nettsiden finnes ikke!"}})}
var staticRenderFns = []

export { render, staticRenderFns }